/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Ship_ControlsInputs */

const ja_calendar_ship_controls = /** @type {(inputs: Calendar_Ship_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← → 移動 • スペース / クリック 発射 • Q E 弾種変更`)
};

const en_calendar_ship_controls = /** @type {(inputs: Calendar_Ship_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← → move • SPACE / click shoot • Q E ammo`)
};

/**
* | output |
* | --- |
* | "← → move • SPACE / click shoot • Q E ammo" |
*
* @param {Calendar_Ship_ControlsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_ship_controls = /** @type {((inputs?: Calendar_Ship_ControlsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Ship_ControlsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_ship_controls(inputs)
	return en_calendar_ship_controls(inputs)
});